module.exports = __webpack_public_path__ + "img/back3.0eee89ec.jpg";